import DataTable, { type DataTableColumn } from '../components/DataTable';
import MetricCard from '../components/MetricCard';
import PageHeader from '../components/PageHeader';
import SectionCard from '../components/SectionCard';
import { nameOf, payrollForMonth, payrollSummary } from '../data/mockHelpers';
import { employees } from '../data/mock';
import type { PayrollRecord } from '../data/mock';
import DashboardLayout from '../components/DashboardLayout';
import { dashboardSidebar, dashboardUser, type BusinessPageProps } from './dashboardSidebar';

const MOCK_MONTH = '2026-06';

function fmtCurrency(n: number): string {
  return `¥ ${n.toLocaleString('zh-CN')}`;
}

const payrollColumns: DataTableColumn<PayrollRecord>[] = [
  { key: 'employeeId', header: '员工', cell: (r) => nameOf(employees, r.employeeId) },
  { key: 'month', header: '月份', cell: (r) => r.month, align: 'center' },
  {
    key: 'base',
    header: '基本工资',
    cell: (r) => fmtCurrency(r.base),
    align: 'right',
    numeric: true
  },
  {
    key: 'bonus',
    header: '奖金',
    cell: (r) => fmtCurrency(r.bonus),
    align: 'right',
    numeric: true
  },
  {
    key: 'deduction',
    header: '扣除',
    cell: (r) => fmtCurrency(r.deduction),
    align: 'right',
    numeric: true
  },
  {
    key: 'net',
    header: '实发',
    cell: (r) => <strong>{fmtCurrency(r.net)}</strong>,
    align: 'right',
    numeric: true
  }
];

function PayrollPage(props: BusinessPageProps) {
  const rows = payrollForMonth(MOCK_MONTH);
  const summary = payrollSummary(MOCK_MONTH);

  return (
    <DashboardLayout
      sidebar={dashboardSidebar}
      user={dashboardUser}
      pageTitle={{ heading: '薪酬管理', sub: '' }}
      metrics={[]}
      chart={{ title: '', data: [], xLabels: [] }}
      quickAccess={[]}
      activeSidebarId="payroll"
      omitPageTitle
      settingsPanel={props.settingsPanel}
      mobileMenu={props.mobileMenu}
      sidebarOpen={props.sidebarOpen}
    >
      <PageHeader
        heading="薪酬管理"
        sub={`${MOCK_MONTH} · ${rows.length} 条薪酬记录`}
        actions={
          <>
            <button type="button">导出工资条</button>
            <button type="button" className="is-primary">发放</button>
          </>
        }
      />
      <div className="axi-section">
        <div className="axi-metric-grid">
          <MetricCard label="本月应发" value={fmtCurrency(summary.totalBase + summary.totalBonus)} icon="wallet" />
          <MetricCard label="奖金总额" value={fmtCurrency(summary.totalBonus)} unit="元" icon="trophy" neutral />
          <MetricCard label="扣除总额" value={fmtCurrency(summary.totalDeduction)} unit="元" icon="document" neutral />
          <MetricCard label="实发总额" value={fmtCurrency(summary.totalNet)} icon="check" />
        </div>
      </div>
      <SectionCard
        title={`${MOCK_MONTH} 工资单`}
        description="按 mock 顺序展示,数值由 src/data/mock.ts 派生"
      >
        <DataTable<PayrollRecord>
          columns={payrollColumns}
          rows={rows}
          rowKey={(r) => r.id}
        />
      </SectionCard>
    </DashboardLayout>
  );
}

export default PayrollPage;